import { Link, useNavigate } from "react-router-dom";
import { checkButtonAccess, renderStatus } from "../../../../Utils/CommonUtils";
import { Button } from "react-bootstrap";
import { setPspSwitch } from "../../../../slices/psp/serviceProvider/reducer";
import { setSelectedUser } from "../../../../slices/header/headerSlice";
import rootReducer from "../../../../store";

const useServiceProviderColumns = () => {
  const navigate = useNavigate();
  const serviceProviderColumns = [
    {
      header: "Code",
      accessorKey: "code",
      cell: (props) => (
        <Link
          className="table-drilling-link"
          to={`/psp/psp/update/${props.row.original.entityid}`}
        >
          {props?.getValue() ? props?.getValue() : "-"}
        </Link>
      ),
      size: 100,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Created Date",
      accessorKey: "created_date",
      // cell: (props) => {
      //   {props?.getValue() ? props?.getValue() : "-"}
      // },
      size: 200,
    },
    {
      header: "Category",
      accessorKey: "buss_category",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Contact Person",
      accessorKey: "pri_contact_name",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Contact Number",
      accessorKey: "pri_contact_number",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },

    {
      header: "Status",
      accessorKey: "status",
      cell: (props) =>
        props?.getValue() ? renderStatus(props?.getValue()) : "-",
      size: 160,
    },
    {
      header: "Action",
      accessorKey: "action",
      cell: (props) => (
        <div>
          <Button
            className="primary-outline"
            onClick={() => {
              const selectedData = {
                name: props.row.original.name,
                providerName: props.row.original.entitytype,
                buss_category: props.row.original.buss_category,
                code: props.row.original.code,
                entityid: props.row.original.entityid,
                entitytype: props.row.original.entitytype,
                organizationid: props.row.original.organizationid,
                owner_id: props.row.original.owner_id,
                organization_type: props.row.original.organization_type,
                agsa_icon_media_url: props.row.original.agsa_icon_media_url,
              };
              rootReducer.dispatch(setSelectedUser(selectedData));
              rootReducer.dispatch(
                setPspSwitch(props?.row?.original?.entityid)
              );
              navigate("/hub/information");
            }}
          >
            {/* <i className="ri-pencil-fill align-bottom" /> */}
            Manage
          </Button>
        </div>
      ),
      meta: { align: "center" },
      size: 150,
    },
  ];

  return { serviceProviderColumns };
};
export default useServiceProviderColumns;
